// Loose name matching between Axle policy insureds and the reservation's drivers.
// Ignores case, accents, punctuation and suffixes (Jr, Sr, II...), tolerates middle names /
// initials and a surname split across fields, and accepts "Last First" order.

const NAME_SUFFIXES = new Set(["jr", "sr", "ii", "iii", "iv"]);

export const toNameTokens = (value) =>
    String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/['’.]/g, "")
        .replace(/[^a-z]+/g, " ")
        .trim()
        .split(" ")
        .filter((token) => token && !NAME_SUFFIXES.has(token));

// Same first name, and at least one shared surname token (single-letter initials don't count)
const matchesInOrder = (a, b) =>
    a[0] === b[0] && a.slice(1).some((token) => token.length > 1 && b.slice(1).includes(token));

export const namesMatch = (nameA, nameB) => {
    const a = toNameTokens(nameA);
    const b = toNameTokens(nameB);
    if (a.length === 0 || b.length === 0) return false;
    if (a.length < 2 || b.length < 2) return a.join(" ") === b.join(" ");
    return matchesInOrder(a, b) || matchesInOrder(a, [...b].reverse());
};

const joinName = (person) =>
    [person?.firstName, person?.lastName].filter(Boolean).join(" ").trim() || String(person?.name || "").trim();

export const getAxleNameCheck = (resDetails, policy) => {
    const insuredNames = (policy?.insureds || []).map(joinName).filter(Boolean);

    const drivers = [
        { role: "renter", name: joinName(resDetails) },
        { role: "additionalDriver", name: joinName(resDetails?.additionalDriver) },
    ]
        .filter((driver) => driver.name)
        .map((driver) => ({
            ...driver,
            matchedInsuredName: insuredNames.find((insuredName) => namesMatch(insuredName, driver.name)) || null,
        }));

    return {
        insuredNames,
        drivers,
        matchedRoles: drivers.filter((driver) => driver.matchedInsuredName).map((driver) => driver.role),
    };
};
